export enum QuizTypeEnum {
  Normal = 'normal',
  Rand = 'rand',
}
